import { IS_PORTAL, jewlr_t, reverse_t } from "./application"
import getSpecialPaths from "./special-paths"

export const getHreflangs = (path) => {
  let defaultHref = ""
  const specialPaths = getSpecialPaths[path]
  let result = Object.entries(sl.config.site_url_by_country || {})
    .filter(([country]) => !specialPaths || specialPaths.includes(country))
    .map(([country, url]) => {
      const locale = (sl.locales || {})[country.toLowerCase()]
      const localizedPath = reverse_t(path, locale)
      const href = `${url}${localizedPath}`

      if (country === "US") {
        defaultHref = href
      }

      return {
        href,
        hreflang: locale,
      }
    })

  if (defaultHref) {
    result.push({
      href: defaultHref,
      hreflang: "x-default",
    })
  }

  return result
}

export const getMetaDescription = () =>
  `Design the perfect custom necklaces, rings, earrings, and bracelets made from high-quality, ${jewlr_t("terms.personalized")} materials and gemstones for men and women, from Jewlr.`

export const getMetaKeywords = () =>
  `fine ${jewlr_t("terms.jewelry")}, ${jewlr_t("terms.jewelry")}, mothers rings, mothers ring, mother's ring, mother's rings, birthstone ${jewlr_t("terms.jewelry")}, mothers birthstone ${jewlr_t("terms.jewelry")}, family ${jewlr_t("terms.jewelry")}, custom made ${jewlr_t("terms.jewelry")}, custom ${jewlr_t("terms.jewelry")}, ${jewlr_t("terms.personalized")} ${jewlr_t("terms.jewelry")}`

export const getMetaIcons = () =>
  IS_PORTAL()
    ? {
        appleIcon: "cyj/apple-touch-icon.png",
        favicon: "cyj/favicon.ico",
        ogImage: "cyj/cyj-logo.jpg",
        png: "cyj/favicon-96x96.png",
        svg: "cyj/favicon.svg",
      }
    : {
        appleIcon: "jewlr/apple-touch-icon.png",
        favicon: "jewlr/favicon.ico",
        ogImage: "jewlr/jewlr-logo.jpg",
        png: "jewlr/favicon-96x96.png",
        svg: "jewlr/favicon.svg",
      }
